var map = {
	"./android-icon.svg": 2161,
	"./app-img.png": 2162,
	"./app-qr-code-bg.png": 2163,
	"./apple-icon.svg": 2164,
	"./contact-bg.png": 2165,
	"./contact-us-bg.jpg": 2166,
	"./contact-us-main-bg.webp": 2167,
	"./qr-bg.png": 2168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2160;